<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="月份：">
				<el-date-picker
					v-model="monthDate"
					size="small"
					type="month"
					value-format="yyyy-MM"
					format="yyyy年MM月"
					placeholder="请选择月份"
					@change="handleMonthChange"
				></el-date-picker>
			</el-form-item>
			<el-form-item label="所属门店：">
				<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable @change="handleStoreChange">
					<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="类别">
				<el-select v-model="formInline.typeName" placeholder="请选择类别" clearable filterable size="small" @change="handleTypeNameChange">
					<el-option v-for="item in typeNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="系列">
				<el-select v-model="formInline.productName" placeholder="请选择系列" clearable filterable size="small" @change="handleProductNameChange">
					<el-option v-for="item in productNameList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品名称：">
				<el-input v-model="formInline.specification" placeholder="请输入商品名称" clearable size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</el-form-item>
		</el-form>
		<div class="stat-title">{{ title }}</div>
		<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="rowNumber" height="560">
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
	</div>
</template>

<script>
import { GetStoreSubscriptionStatistics, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
	props: {
		storeList: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				month: "",
				typeName: "",
				productName: "",
				specification: ""
			},
			columnsData: [],
			typeNameList: [],
			productNameList: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					width: "80",
					align: "center",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "所属门店",
					width: "140",
					align: "center"
				},
				{
					prop: "month",
					label: "年月",
					width: "100",
					align: "center"
				},
				{
					prop: "typeName",
					label: "类型",
					width: "130",
					align: "center"
				},
				{
					prop: "productName",
					label: "系列",
					width: "130",
					align: "center"
				},
				{
					prop: "specification",
					label: "商品名称",
					width: "180",
					align: "center"
				},
				{
					prop: "productBrand",
					label: "商品品牌",
					width: "130",
					align: "center"
				},
				{
					prop: "unit",
					label: "单位",
					width: "80",
					align: "center"
				}
			],
			stateList: [],
			monthDate: "",
			title: ""
		};
	},
	created() {
		// 月份必填，默认当前年月
		this.monthDate = this.getCurrentMonth();
		this.formInline.month = this.monthDate;
		this.getEnumConfigListByCode();
		this.getProductTypeNameList();
		this.getProductTypeSubNameList(this.formInline.typeName);
		this.buildColumns();
		this.getListData();
	},
	methods: {
		// 获取状态枚举，动态生成状态列
		getEnumConfigListByCode() {
			const paramer = {
				code: "StoreSubscriptionState"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.buildColumns();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取状态信息失败!");
				});
		},
		// 动态生成列：商品信息 + 各状态数量列 + 申购总数量 + 已到货数量
		buildColumns() {
			let columns = JSON.parse(JSON.stringify(this.listColumns));
			this.stateList.forEach((item) => {
				columns.push({
					prop: "state" + item.code + "Qty",
					label: item.name,
					width: "100",
					align: "center"
				});
			});
			columns.push(
				{
					prop: "totalQty",
					label: "申购总数量",
					width: "120",
					align: "center"
				},
				{
					prop: "realQty",
					label: "已到货数量",
					width: "120",
					align: "center"
				}
			);
			this.columnsData = columns;
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreSubscriptionStatistics(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
						// 标题由后端按月份 + 数据权限范围内的门店组装
						this.title = res.title || "";
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取类别下拉
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					res.data.forEach((item) => {
						this.typeNameList.push({
							keyId: item.value,
							value: item.value
						});
					});
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 根据类别获取系列下拉（类别为空时返回全部系列）
		getProductTypeSubNameList(code) {
			var params = {
				code: code
			};
			GetProductTypeSubNameList(params).then((res) => {
				if (res.code == 1) {
					this.productNameList = [];
					res.data.forEach((item) => {
						this.productNameList.push({
							keyId: item.value,
							value: item.value
						});
					});
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 类别选择事件：联动加载系列，清空已选系列
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.search();
		},
		// 系列选择事件
		handleProductNameChange(val) {
			this.formInline.productName = val;
			this.search();
		},
		// 月份选择事件（月份必填，为空时兜底为当前年月）
		handleMonthChange(val) {
			if (!val) {
				this.monthDate = this.getCurrentMonth();
			}
			this.formInline.month = this.monthDate;
			this.search();
		},
		// 门店选择事件
		handleStoreChange(val) {
			this.formInline.storeKeyId = val;
			this.search();
		},
		// 获取当前年月（yyyy-MM）
		getCurrentMonth() {
			var now = new Date();
			var month = now.getMonth() + 1;
			return now.getFullYear() + "-" + (month < 10 ? "0" + month : month);
		}
	}
};
</script>

<style scoped>
	.stat-title {
		font-size: 16px;
		font-weight: bold;
		color: #303133;
		text-align: center;
		padding: 10px 0;
	}
</style>
